import React from 'react';
import FormikTextField from 'src/components/FormikTextField/FormikTextField';
import {Formik, Field, Form} from 'formik';
import EducatorVerificationService, {
  PendingEducator,
} from 'src/services/EducatorVerificationService';
import {Box} from '@mui/material';
import Button from 'src/components/button';
import {errorMessage, flashMessage} from 'shared/actions/notifications';
import {useDispatch} from 'react-redux';

interface RejectFormProps {
  educator: PendingEducator;
  closeForm: () => void;
  refreshList: () => Promise<void>;
}

export default function RejectForm(props: RejectFormProps) {
  const dispatch = useDispatch();
  const {educator, closeForm, refreshList} = props;

  const handleReject = async (values) => {
    try {
      await EducatorVerificationService.reject(educator._id, values);
      dispatch(flashMessage('Educator was successfully rejected.'));
      await refreshList();
      closeForm();
    } catch (err) {
      console.log(err);
      dispatch(errorMessage());
    }
  };

  return (
    <Formik initialValues={{}} onSubmit={handleReject}>
      <Form>
        <Box mb={4}>
          <div>
            Reject and notify{' '}
            <strong>
              {educator.firstName} {educator.lastName}
            </strong>
          </div>
          <Box my={2}>
            <FormikTextField type="textarea" name="reason" placeholder="Reason for rejection" />
          </Box>
          <div>Fields to reset because they are currently wrong:</div>
          <ul>
            <li>
              <Field type="checkbox" name="linkedin" /> <span>Bad Linkedin</span>
            </li>
            <li>
              <Field type="checkbox" name="photo" /> <span>Bad Photo ID</span>
            </li>
            <li>
              <Field type="checkbox" name="avatar" /> <span>Bad Avatar</span>
            </li>
          </ul>
          <Button type="submit">Send Rejection Notice</Button>{' '}
          <Button outline onClick={closeForm}>
            Close Rejection Form
          </Button>
        </Box>
      </Form>
    </Formik>
  );
}
